import { createContext, use } from 'react';
import { Theme } from '@nivo/theming';
import { ModeCategory } from '@commutifi/modes';
import { ChartsTokens, dynamicColors } from '../theme/index';
import { colors } from '../theme/colors';
export interface ChartsThemeContextValue {
  customPalettes?: {
    blue: string[];
    blueDescending: string[];
    perModeCategory: Record<ModeCategory, string[]>;
  };
  colorScheme?: string;
  theme?: Theme;
  tokens: ChartsTokens;
}
export const defaultConfig: ChartsThemeContextValue = {
  customPalettes: {
    blue: [colors.neutralBlue500, colors.neutralBlue200, colors.neutralBlue600, colors.neutralBlue100, colors.neutralBlue400, colors.neutralBlue300],
    blueDescending: [colors.neutralBlue600, colors.neutralBlue500, colors.neutralBlue400, colors.neutralBlue300, colors.neutralBlue200, colors.neutralBlue100],
    perModeCategory: {
      [ModeCategory.Bike]: [colors.accentMint500],
      [ModeCategory.Carpool]: [colors.accentYellow200],
      [ModeCategory.Drive]: [colors.accentPurple500],
      [ModeCategory.PublicTransit]: [colors.accentGreen400],
      [ModeCategory.Remote]: [colors.accentPink400],
      [ModeCategory.SharedRide]: [colors.accentBeige400],
      [ModeCategory.Walk]: [colors.accentPistachio300],
      [ModeCategory.None]: [colors.neutralBlue500]
    }
  },
  tokens: dynamicColors
};
export const ChartsThemeContext = createContext<Omit<ChartsThemeContextValue, 'children'>>(defaultConfig);
export const useChartsTheme = () => {
  const context = use(ChartsThemeContext);
  return context;
};